import React, { Component } from 'react'
import logo from '../../../assets/img/logo.png'
import search from '../../../assets/images/search.svg'
import profile from '../../../assets/images/profile.webp'
import bell from '../../../assets/images/bell.svg'
import pluscirclefill from '../../../assets/images/plus-circle-fill.svg'
import {ReactComponent as Back} from '../../../assets/images/back.svg'
import { Redirect ,Link } from 'react-router-dom';
import axios from 'axios';
import Sidebar from './Sidebar'
import { APIURL, BASEURL } from '../../../components/constants/common';

export default class Navbar extends Component {
    constructor() {
        super();
        this.state = {
            token: JSON.parse(localStorage.getItem("token")),
            user: JSON.parse(localStorage.getItem("userData")),
            user_type: localStorage.getItem("user_type"),
            navigate: false,
            profile_image:"",
            name:"",
            openSidebar:false
        }
    }

    componentDidMount() {
        this.setState({
            openSidebar: false
        })
        this.getProfileInfo()
    }

    getProfileInfo() {
        if (this.state.user) {
            const formData = new FormData();
            // formData.append('token', this.state.token);
            formData.append('id', this.state.user.id);
            var token = this.state.token
            var app_url = APIURL+"seller/edit-profile"
            axios
                .post(app_url, formData, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                })
                .then((response) => {
                    const info = response.data.data;
                    this.setState({
                        profile_image: response.data.data.url_path,
                        name:response.data.data.name
                    })
                 
                })
                .catch((error) => {
                    this.setState({
                        // errMsg: error.response.data.errors,
                        Loader: false
                    })
                });
        }
    }

    onLogoutHandler = () => {
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("userData");
        localStorage.clear();
        this.setState({
            navigate: true,
        });
    };

    onHover = () =>  
    this.setState({ 
        showIcons: true 
    });
 onNotHover = () =>  
    this.setState({ 
        showIcons: false 
    });

    Sidebar = (event) => {
        this.setState({
            openSidebar: !this.state.openSidebar
        })
        if(this.state.openSidebar){
            document.body.classList.remove('sidebar-icon-only');
        }
        if(!this.state.openSidebar){
            document.body.classList.add('sidebar-icon-only');
        }
    }
    goToHome(){
        window.location.href="/";
    }

    render() {
        const {openSidebar ,closeSidebar } = this.state 
        const { user ,name } = this.state

        if (!this.state.user_type === "User") {
            return <Redirect to="/" push={true} />;
        }

        if (!this.state.user) {
            return <Redirect to="/" push={true} />;
        }

        if (this.state.navigate) {
            return <Redirect to="/" push={true} />;
        }
        return (
            <>
            
             <header>
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="position-relative">
                    
                    </div>
                    <div>
                      <div class="d-flex justify-content-between align-items-center ml-3 additional-link">                      
                        <div>
                          <a href="#"  class="notification">
                            {/* <img src={bell} class="img-svg" alt="search" />
                            <span></span> */}
                          </a>
                        </div>
                        <div>
                          <div class="dropdown animate-click">
                            <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false"> 
                              <span class="img"><img  src={this.state.profile_image ? this.state.profile_image : profile} class="img-svg" alt="search" /></span> 
                              <span class="text">{this.state.name}</span>
                            </a>

                            <ul class="dropdown-menu animate" aria-labelledby="dropdownMenuLink">
                            
                              <li><a class="dropdown-item" href="#" onClick={() => this.onLogoutHandler()}>Logout</a></li>
                            </ul>
                          </div>
                        </div>
                       
                      </div>
                    </div>
                  </div>
                </header>
                
            </>
        )
    }
}
